import { Store } from 'redux';
import { AppState } from '../appState';

export const getStore = (): Store<AppState> => {
  return window.appStore;
};
